<template>
  <div class="codeconduct bg-color-dark pb-5">
    <vue-headful
    :title="doctitle"

    />
    <b-container>
      <b-row>
        <b-col xl="1"></b-col>
        <b-col>
          <h1 class="mt-5 text-color-light big-headline">Code of Conduct Öredev AB</h1>
          <p class="p-margin-bottom" >

           Like the technical community as a whole, Öredev AB communities are made up of a mixture of professionals and volunteers from all over the world. Diversity is one of our huge strengths, but it can also lead to communication issues and unhappiness. To that end, we have a few ground rules that we ask people to adhere to. This code applies equally to participants, partners, founders, mentors. This isn’t an exhaustive list of things that you can’t do. Rather, take it in the spirit in which it’s intended – a guide to make it easier to enrich all of us and the technical communities in which we participate.
          </p>
          <p class="p-margin-bottom" >
            This Code of Conduct applies to all spaces managed by Öredev AB and its projects. This includes the mailing lists, social media channels, all the events, and any other forums created by Öredev AB which the community uses for communication. In addition, violations of this code outside these spaces may affect a person’s ability to participate within them. If you believe someone is violating the Code of Conduct, we ask that you report it by emailing info@oredev.org.
          </p>
          <h2 class="text-color-light headline-margin-top ">Be friendly and patient</h2>
          <p class="p-margin-bottom" >
   We understand that everyone has different levels of experience or knowledge in many diverse fields, be it technical or non-technical in nature. We also have areas of knowledge we are eager to expand; we want to be a community where people can not only contribute, but feel comfortable to ask questions as well and learn along the way. If someone says something wrong, or says something accidentally offensive, respond with patience and try to keep it polite and civil. Remember that we all were newbies at one point.
          </p>
          <h2 class="text-color-light headline-margin-top ">Be welcoming</h2>
          <p class="p-margin-bottom" >
            We strive to be a community that welcomes and supports people of all backgrounds and identities. This includes, but is not limited to, members of any race, ethnicity, culture, national origin, color, immigration status, social and economic class, educational level, sex, sexual orientation, gender identity and expression, age, size, family status, political belief, religion, and mental and physical ability.
          </p>
          <h2 class="text-color-light headline-margin-top ">Be considerate</h2>
          <p class="p-margin-bottom" >
            Your work will be used by other people, and you in turn will depend on the work of others. Any decision you make will affect users and colleagues, and you should take those consequences into account when making decisions. Remember that we’re a world-wide community, so you might not be communicating in someone else’s primary language.
          </p>
          <h2 class="text-color-light headline-margin-top ">Be respectful</h2>
          <p class="p-margin-bottom" >
            Not all of us will agree all the time, but disagreement is no excuse for poor behavior and poor manners. We might all experience some frustration now and then, but we cannot allow that frustration to turn into a personal attack. It’s important to remember that a community where people feel uncomfortable or threatened is not a productive one.
          </p>
          <h2 class="text-color-light headline-margin-top ">Be careful in the words that you choose</h2>
          <p class="p-margin-bottom" >
           We are a community of professionals, and we conduct ourselves professionally. Be kind to others. Do not insult or put down other participants. Harassment and other exclusionary behavior aren’t acceptable. This includes, but is not limited to:
            <ul>
              <li>Violent threats or language directed against another person.</li>
              <li>Discriminatory jokes and language.</li>
              <li>Posting sexually explicit or violent material.</li>
              <li>Posting (or threatening to post) other people’s personally identifying information (“doxing”).</li>
              <li>Personal insults, especially those using racist or sexist terms.</li>
              <li>Unwelcome sexual attention.</li>
              <li>Advocating for, or encouraging, any of the above behavior.</li>
              <li>Repeated harassment of others. In general, if someone asks you to stop, then stop.</li>
            </ul>
          </p>
          <h2 class="text-color-light headline-margin-top ">When we disagree, try to understand why</h2>
          <p class="p-margin-bottom" >
           Disagreements, both social and technical, happen all the time. It is important that we resolve disagreements and differing views constructively. Remember that we’re different. The strength of the Øredev events comes from its varied community, people from a wide range of backgrounds. Different people have different perspectives on issues. Being unable to understand why someone holds a viewpoint doesn’t mean that they’re wrong. Don’t forget that it is human to err and blaming each other doesn’t get us anywhere. Instead, focus on helping to resolve issues and learning from mistakes.
          </p>
          <p class="p-margin-bottom" >QUESTIONS?</p>
          <p class="p-margin-bottom" >
           If you have questions, feel free to email info@oredev.org.

          </p>
          <p class="p-margin-bottom" >
            If you believe someone is violating the Code of Conduct we ask that you report it to the Öredev AB by emailing info@oredev.org. All reports will be kept confidential. This is not a public list and only members of the Code of Conduct Committee will receive the report.
          </p>
          <p class="p-margin-bottom" >
          
In some cases we may determine that a public statement will need to be made. If that’s the case, the identities of all victims and reporters will remain confidential unless those individuals instruct us otherwise.
          </p>

          <h5 class="orange headline-margin-top " >If you believe anyone is in physical danger, please notify appropriate law enforcement first</h5>
          <p class="p-margin-bottom" >
           If you are unsure what law enforcement agency is appropriate, please include this in your report and we will attempt to notify them.

          </p>
          <p class="p-margin-bottom " >
          In your report please include:
            <ul>
              <li>Your contact info (so we can get in touch with you if we need to follow up).</li>
              <li>Names (real, nicknames, or pseudonyms) of any individuals involved. If there were other witnesses besides you, please try to include them as well.</li>
              <li>When and where the incident occurred. Please be as specific as possible.</li>
              <li>Your account of what occurred. If there is a publicly available record please include a link. Screenshots can be useful in the case something is edited or deleted before action is taken.</li>
              <li>Any extra context you believe existed for the incident.</li>
              <li>If you believe this incident is ongoing.</li>
              <li>Any other information you believe we should have.</li>
            </ul>
          </p>
          <h2 class="text-color-light headline-margin-top ">What happens after you file a report?</h2>
          <p class="p-margin-bottom" >
            Reports will receive urgent and immediate attention from the Code of Conduct Committee. Possible responses may include:

            <ul>
              <li>Taking no further action (if we determine no violation occurred).</li>
              <li>A private reprimand from the committee to the individual(s) involved. In this case, the committee chair will deliver that reprimand to the individual(s) over email, cc’ing the committee.</li>
              <li>A public reprimand. In this case, the committee chair will deliver that reprimand in the same venue that the violation occurred (e.g. in IRC for an IRC violation; email for an email violation). The committee may choose to publish this message elsewhere for posterity.</li>
              <li>A permanent or temporary ban from some or all Öredev AB spaces. The committee will maintain records of all such bans so that they may be reviewed in the future, extended to new Öredev AB forum, or otherwise maintained.</li>
              <li>A request for a public or private apology. The chair will deliver this request. The committee may, if it chooses, attach “strings” to this request: for example, the committee may ask a violator to apologize in order to not be banned from any space.</li>
              <li>Once a resolution is agreed upon, but before it is enacted, the committee will contact the original reporter and any other affected parties and explain the proposed resolution. The committee will ask if this resolution is acceptable, and must note feedback for the record. </li>
            </ul>
          </p>
          <p class="p-margin-bottom" >
Original text courtesy of the Speak Up! project and Django Project.          </p>
        </b-col>
        <b-col xl="1"></b-col>
      </b-row>
        <img
        class="d-none d-xl-block position-absolute"
        id="white-shape-1"
        src="https://res.cloudinary.com/oredev/image/upload/v1679424057/2023_web/shapes%20lp/white-shape-1.png"
      />
      <img
        class="d-none d-xl-block position-absolute"
        id="white-shape-2"
        src="https://res.cloudinary.com/oredev/image/upload/v1683012353/2023_web/white-shape-2.png"
      />
      <img
        src="https://res.cloudinary.com/oredev/image/upload/v1679424058/2023_web/shapes%20lp/white-shape-5.png"
        class="d-none d-xl-block position-absolute"
        id="white-shape-3"
      />
      <img
        class="d-none d-xl-block position-absolute"
        id="white-shape-4"
        src="https://res.cloudinary.com/oredev/image/upload/v1680087567/2023_web/shapes%20info/white-shape-3.png"
        alt="rectangle"
      />
 

      <img
        class="d-none d-xl-block  position-absolute"
        id="white-shape-6"
        src="https://res.cloudinary.com/oredev/image/upload/v1680088576/2023_web/shapes%20info/white-shape-6.png"
        alt="rectangle"
      />
      <img
        class="d-none d-xl-block position-absolute"
        id="white-shape-7"
        src="https://res.cloudinary.com/oredev/image/upload/v1680090042/2023_web/shapes%20info/white-shape-5.png"
        alt="rectangle"
      />
      <img
        class="d-none d-xl-block position-absolute"
        id="white-shape-8"
        src="https://res.cloudinary.com/oredev/image/upload/v1680089901/2023_web/shapes%20info/white-shape-7.png"
        alt="rectangle"
      />


      <img
        class="rectangle-long-1 position-absolute"
        src="https://res.cloudinary.com/oredev/image/upload/v1678533180/2023_web/temp/%C3%98redev_2023.png"
      />

      <img
        class="rectangle-green-short position-absolute"
        id="green-2"
        src="https://res.cloudinary.com/oredev/image/upload/v1679666601/2023_web/shapes%20info/Blue-shape-1.png"
        alt="rectangle"
      />
      <img
        class="rectangle-green-short position-absolute"
        id="green-3"
        src="https://res.cloudinary.com/oredev/image/upload/v1679903087/2023_web/shapes%20info/Blue-shape-2.png"
        alt="rectangle"
      />
      <img
        class="rectangle-green-short position-absolute"
        id="green-4"
        src="https://res.cloudinary.com/oredev/image/upload/v1679903087/2023_web/shapes%20info/Blue-shape-2.png"
        alt="rectangle"
      />
      <!-- here -->
       <img
        class="rectangle-orange position-absolute"
        id="orange-3"
        src="https://res.cloudinary.com/oredev/image/upload/v1678533180/2023_web/temp/%C3%98redev_2023.png"
      />
          <img
        class="rectangle-green-short position-absolute"
        id="green-5"
        src="https://res.cloudinary.com/oredev/image/upload/v1679903087/2023_web/shapes%20info/Blue-shape-2.png"
        alt="rectangle"
      />
         <img
        class="rectangle-orange position-absolute"
        id="orange-4"
        src="https://res.cloudinary.com/oredev/image/upload/v1678533180/2023_web/temp/%C3%98redev_2023.png"
      />
      <img
        class="rectangle-green-short position-absolute"
        id="green-6"
        src="https://res.cloudinary.com/oredev/image/upload/v1679903087/2023_web/shapes%20info/Blue-shape-2.png"
        alt="rectangle"
      />
    </b-container>
  </div>
</template>

<script>
export default {
  name: "conduct",
  data() {
    return {
      doctitle: "Code of Conduct - " + this.$store.state.conferencename,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/variables.scss";
p {
  color: $text-color-light;
}

h1 {
  font-weight: 400;
  font-size: 32px;
}
h2 {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
}

.rectangle-long-1 {
  width: 100%;
  height: 30px;
  mix-blend-mode: color;
  position: absolute;
  bottom: -196%;
  left: 0;
}
.rectangle-long-2 {
  width: 100%;
  height: 30px;
  mix-blend-mode: color;
  position: absolute;
  top: 100%;
  left: 0;
}

.rectangle-green-short,
.rectangle-orange {
  mix-blend-mode: color !important;
}

#green-2 {
  bottom: 50%;
  right: 0;
  z-index: 0;
  height: 16px;
  width: 51%;
}
#green-3 {
  bottom: 29%;
  left: 0;
  max-width: 80%;
  z-index: 0;
}
#green-4 {
  bottom: 17.5%;
  max-width: 58%;
  z-index: 1;
  right: 0;
}
#green-5 {
  bottom: -80%;
  left: 0;
  max-width: 80%;
  z-index: 0;
}
#green-6 {
  bottom: -130%;
  max-width: 58%;
  z-index: 1;
  right: 0;
}
#orange-3 {
  bottom: -50%;
  right: 0;
  z-index: 0;
  height: 16px;
  width: 51%;
}
#orange-4 {
  bottom: -110%;
  left: 0;
  width: 60%;
  height: 16px;
  z-index: 0;
}

#white-shape-1 {
  right: 30px;
  bottom: 75%;
}
#white-shape-2 {
  right: 35px;
  bottom: 71%;
}
#white-shape-2-mobile {
  right: 35px;
  bottom: 64%;
}
#white-shape-3 {
  right: 0;
  bottom: 37%;
  width: 16%;
}
#white-shape-4 {
  left: 3%;
  bottom: 37%;
}
#white-shape-5 {
  left: 3%;
  bottom: 13%;
}
#white-shape-6 {
  right: 3%;
  bottom: -22%;
}
#white-shape-7 {
  left: 3%;
  bottom: 10%;
}
#white-shape-8 {
  right: 3%;
  bottom: 13%;
}
</style>



// WEBPACK FOOTER //
// src/components/Conduct.vue